module.exports = __webpack_public_path__ + "img/internal-cloud.f184f9d.svg";